export interface Device {
  Label: string;
  Icon: string;
  Image: string;
  Type: string;
  EnumValue: number;
}

export const devices: Device[] = [
  {
    Label: 'ES2000',
    Icon: 'assets/images/icon/es-2000.png',
    Image: 'assets/images/devices/fpo-es-2000-dishmachine.jpg',
    Type: '',
    EnumValue: 1,
  },
  {
    Label: 'EHT',
    Icon: 'assets/images/icon/eht.png',
    Image: 'assets/images/devices/fpo-eht-dishmachine.jpg',
    Type: '',
    EnumValue: 2,
  },
  {
    Label: 'ELT',
    Icon: 'assets/images/icon/elt.png',
    Image: 'assets/images/devices/fpo-elt-dishmachine.jpg',
    Type: 'Low Temp',
    EnumValue: 3,
  },
  {
    Label: 'EUHT',
    Icon: 'assets/images/icon/e-uht.png',
    Image: 'assets/images/devices/fpo-uht-dishmachine.jpg',
    Type: '',
    EnumValue: 4,
  },
  {
    Label: 'EULT',
    Icon: 'assets/images/icon/e-ult.png',
    Image: 'assets/images/devices/fpo-uht-dishmachine.jpg',
    Type: 'Low Temp',
    EnumValue: 5,
  },
  {
    Label: 'XLHT',
    Icon: 'assets/images/icon/xlht.png',
    Image: 'assets/images/devices/fpo-xl-ht-dishmachine.jpg',
    Type: '',
    EnumValue: 6,
  },
  {
    Label: 'EH500S',
    Icon: 'assets/images/icon/eh-500s.png',
    Image: 'assets/images/devices/fpo-eh500s-dishmachine.jpg',
    Type: '',
    EnumValue: 7,
  },
  {
    Label: 'XLRW',
    Icon: 'assets/images/icon/xlht.png',
    Image: 'assets/images/devices/fpo-xl-ht-dishmachine.jpg',
    Type: '',
    EnumValue: 8,
  },
];
